// Marketplace transaction type IDs used in report filters.
//
// app/services/reporting/marketplace_type_constants.rb
const MARKETPLACE_TYPE_IDS = Object.freeze({
  MANAGED: '1',
  DIRECT_CONNECT_SOLD: '2',
  DC_TO_DC: '3',
  DIRECT_CONNECT_BOUGHT: '4',
  OPEN_MARKET_SOLD: '5',
  OPEN_MARKET_BOUGHT: '6',
  DEAL_SOLD: '7',
  DEAL_BOUGHT: '8',
  PLATFORM_DEAL_BOUGHT: '10',
  HOUSE_ADS: '11'
});

export default MARKETPLACE_TYPE_IDS;
